import LearningTimeDonut from '@Components/LearningTimeDonut/LearningTimeDonut'
import { useWidget } from '@eduact/ed-components'
import { useGetUserProfileQuery } from '@Features/Dashboard/DashboardSlice/Dashboard.slice'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const LearningTimeWidget = () => {
	const [t] = useTranslation('studentDashboard')
	const { setTitle } = useWidget()
	const { data } = useGetUserProfileQuery()

	useEffect(() => {
		setTitle(t('learningTime'))
	}, [])

	return <LearningTimeDonut scope={{ user_id: Number(data?.data.student.user_id) }} />
}

export default LearningTimeWidget
